// @flow

import type {Locale} from 'docs/data';

export const DEFAULT_LOCALE_CODE = 'en-US';

// Must start with 2-3 lowercase letters and dash, and must end with 2 uppercase letters or 3 digits
// Can optionally have a script tag to futureproof us for zh flavors
const VALID_LOCALE_REGEX = /^[a-z]{2,3}(-(Hans|Hant))?-([A-Z]{2}|[0-9]{3})$/;

export const isDefaultLocale = (locale: Locale | string) => {
  if (typeof locale === 'string') {
    return locale === DEFAULT_LOCALE_CODE;
  } else {
    return locale.code === DEFAULT_LOCALE_CODE;
  }
};

export function sanitizeLocale(requestedLocale: string) {
  if (VALID_LOCALE_REGEX.test(requestedLocale)) {
    return requestedLocale;
  }
}
